var map = {
	"./007-microphone-1.png": 613,
	"./010-home.png": 614,
	"./013-document-1.png": 615,
	"./014-document.png": 616,
	"./015-color-palette.png": 617,
	"./017-video-camera.png": 618,
	"./024-like.svg": 619,
	"./1.svg": 620,
	"./155-credit-card.svg": 621,
	"./2.svg": 622,
	"./3.svg": 623,
	"./4.svg": 624,
	"./New Customer.svg": 625,
	"./NotOpen.svg": 626,
	"./Opened.svg": 627,
	"./Profit.svg": 628,
	"./SalesRevenue.svg": 629,
	"./Sent.svg": 630,
	"./Slack.svg": 631,
	"./address.svg": 632,
	"./adobe.svg": 633,
	"./arrow-left.svg": 634,
	"./arrow-right.svg": 635,
	"./birlesik-logo.png": 636,
	"./book.svg": 637,
	"./camera.svg": 638,
	"./chat.svg": 639,
	"./clipboard.svg": 640,
	"./cloud.svg": 641,
	"./columns.svg": 642,
	"./documentation.svg": 643,
	"./file.svg": 644,
	"./flat.svg": 645,
	"./headphone.svg": 646,
	"./iconfinder_trello_2317760.svg": 647,
	"./idea.svg": 648,
	"./image.png": 649,
	"./image.svg": 650,
	"./label.png": 651,
	"./layers.svg": 652,
	"./left.svg": 653,
	"./logo2.svg": 654,
	"./logo3.svg": 655,
	"./logo4.svg": 656,
	"./logo5.svg": 657,
	"./logo6.svg": 658,
	"./logoIn.svg": 659,
	"./paint.svg": 660,
	"./protection.svg": 661,
	"./quote.png": 662,
	"./repeat.svg": 663,
	"./right.svg": 664,
	"./strategy.svg": 665,
	"./theme.svg": 666,
	"./user.svg": 667,
	"./water-fall.svg": 668
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 612;